import { jsx as _jsx } from "react/jsx-runtime";
// TODO Remove after running GOSU-0001
import HubInterestMessageFooter from './HubInterestMessageFooter';
import { AnimatedMessaging } from '../animation/MessagingAnimations';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { StyledIllustration, StyledMessagingIllustration } from './Messaging.styles';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';

const HubInterestLandingPage = ({
  messageKey
}) => {
  const {
    illustrationName,
    height
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(illustrationName);
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    isAssignedToVariant: isAssignedGosu0001Variant
  } = useExperiment(ExperimentKeys.GOSU0001, TrackWhen.never);

  if (!isAssignedGosu0001Variant()) {
    return null;
  }

  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    "data-test-id": "hub-interest-landing-page",
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(StyledIllustration, {
      isFramedCentredStep: isFramedCentredStep,
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(BaseMessageCaption, {
        footer: /*#__PURE__*/_jsx(HubInterestMessageFooter, {
          messageKey: messageKey
        }),
        messageKey: messageKey,
        textAlign: "left",
        children: /*#__PURE__*/_jsx(StyledMessagingIllustration, {
          height: height,
          name: illustrationName,
          onLoad: handleImageLoaded
        })
      })
    })
  });
};

export default HubInterestLandingPage;